/**
 * Config em companySettings.settings.client_frontend.hide_chapas_display:
 *  - true: desabilita o desenho/contagem de chapas para toda a company.
 *  - { farms: [pk1, pk2, ...] }: desabilita apenas para as farms listadas.
 */
export function isChapasDisplayHidden(companySettings, farmPk) {
  const cfg = companySettings?.settings?.client_frontend?.hide_chapas_display;
  if (!cfg) return false;
  if (cfg === true) return true;
  const farms = cfg.farms || [];
  return farms.includes(farmPk);
}
